import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { ProductService } from "../../../services/product.service";

import { Catalog, Product } from "../../../models/product.model";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogProductComponent } from "../../dialog-product/dialog-product.component";
import { UserService } from "../../../@core/services/user.service";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { User } from "../../../@core/data/users";
import { DialogPrintProductsComponent } from "../../dialog-print-products/dialog-print-products.component";
import Shop from "../../../models/shop.model";
import { DialogPrintProductBarcodeComponent } from "../../dialog-print-product-barcode/dialog-print-product-barcode.component";

@Component({
  selector: "ngx-view-product",
  styleUrls: ["./view-product.component.scss"],
  templateUrl: "./view-product.component.html",
})
export class ViewProductComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shop?: Shop;
  @Input() shopId?: string = "";
  @Input() units?: Catalog[] = [];
  @Input() groups?: Catalog[] = [];
  @Input() categories?: Catalog[] = [];
  @Input() suppliers?: Catalog[] = [];
  @Input() producers?: Catalog[] = [];
  @Input() origins?: Catalog[] = [];
  @Input() sizes?: Catalog[] = [];
  @Input() colors?: Catalog[] = [];

  @Input() product: Product;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  @Input() mode?: string = ""; //home / product

  isMore? = false;
  loading = false;
  submitted = false;
  view = "main";
  uid = "";
  user: User;
  isMobile = false;
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];

  constructor(
    public userService: UserService,
    private productService: ProductService,
    private dialogService: NbDialogService,
    private router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.product.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadContent() {
    this.isMore = !this.isMore;
  }

  loadButtonAction(item) {
    this.menuItems = [
      { title: "Sửa", icon: "edit-2-outline", data: item },
      { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
      // {
      //   title: "Chi tiết",
      //   icon: "external-link-outline",
      //   link: `/product/${this.product.id}`,
      // },
    ];
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.productService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);

              //sync data to offline DB
              item.isDeleted = true;
              this.productService.sync(item);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: Product) {
    let lecBk = new Product();
    lecBk = clone(item);
    this.dialogService
      .open(DialogProductComponent, {
        context: {
          header: "Cập nhật sản phẩm",
          user: this.user,
          mode: "edit",
          product: lecBk,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.product = value;
          this.onEdit.emit(value);
        }
      });
  }

  viewHistory(item) {
    this.router.navigateByUrl("/product/" + item.id);
  }

  printProduct(item: Product) {
    this.dialogService
      .open(DialogPrintProductBarcodeComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          product: item,
          shop: this.shop,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }
}
